export const workingInList = [
  {Id: '1', Name: 'Private Company'},
  {Id: '2', Name: 'Not Working'},
  {Id: '3', Name: 'Government / Public Sector'},
  {Id: '4', Name: 'Defense / Civil Services'},
  {Id: '5', Name: 'Business / Self Employed'},
];
